module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAZCAMAAACM5megAAAAQlBMVEUAAAAAaGACZ2ABZmABZWABZWABZWABZmABZWAAcGABZmABZWABZmAAZWABZWACZWADZWAAZWAAYGAAY2AFamABZWCLhqn1AAAAFXRSTlMAIJ+A33DvQI8Qr79QMM9/YGAQUDB+qmnKAAAA3klEQVQoz43S64rEIAyG4UQTT9Ue97v/W904sLCdse28IKg8SH5IXzXhoZUIT7luIg+Ss2Ea9Gl02qlOjbgoUVleRqazKaik2CjaDWM2M2v+YflvuNl1XzHbwRblKHAcVY84nGdJPgl6xXvH3RR3KjF6wR/yN0/AW2LGpS1H5ahu7ubwb6kZWlMwXpS9mUHd4JUL65Px1OqdkWSEltt3NmIjuDG7pL0TVIdEowJ8hMQEFBZsQ6MIbYM15QK5/Juh8hw024YvzD4DjnMVs3RZAmBQGt3UBAg+031RM33dLxQdFr7t/QueAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/verify-code.png
// module id = 1bPn
// module chunks = 0